// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"carousel_controlsWrapper__8NNkd","pagination":"carousel_pagination___ES6i","customPagination":"carousel_customPagination__28Eix"};